import React from "react";
import { withRouter } from "react-router-dom";
import {AppBar, Toolbar, Menu, MenuItem, IconButton, Box} from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { useState } from "react";
import {MENU_ITEM_STYLE} from "../../constants/Styles";
import StyledLogo from "../common/StyledLogo";
import {ContainedButton, NavTextButton} from "../common/StyledButtons";
import {DesktopBox, MobileBox} from "../common/Boxes";
import { getEnv } from "../../config";

const ExternalHeader = ({ history }) => {

    const [ menuElement, setMenuElement ] = useState();

    const handleMenuOpen = event => {
        setMenuElement(event.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuElement(undefined);
    };

    const handleNavigate = (url) => {
        window.location.href = url;
    }

    const handleMyAccountOnClick = (e) => {
        e.stopPropagation();
        if(history.location.pathname !== '/register') {
            history.push('/register');
        }
    }

    const renderTestTag = () => (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#f00',
            padding: 8,
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
            fontSize: 12,
            color: '#fff',
            zIndex: 1000
          }}
        >
          {getEnv().toUpperCase()} ENV
        </div>
      )

    const renderMenu = () => (
        <Menu
            anchorEl={menuElement}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={menuElement !== undefined}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={() => handleNavigate('https://consultwithkyle.com/#services')} sx={MENU_ITEM_STYLE} >SERVICES</MenuItem>
            <MenuItem onClick={() => handleNavigate('https://consultwithkyle.com/resources')} sx={MENU_ITEM_STYLE} >RESOURCES</MenuItem>
            <MenuItem onClick={() => handleNavigate('https://consultwithkyle.com/contact-us')} sx={MENU_ITEM_STYLE} >CONTACT</MenuItem>
            <MenuItem onClick={handleMyAccountOnClick} sx={MENU_ITEM_STYLE} >CREATE AN ACCOUNT</MenuItem>
        </Menu>
    )

    return (
        <div style={{ marginTop: '80px' }}>
            <AppBar position="fixed" elevation={3} sx={{ backgroundColor: '#fff', height: 80, paddingTop: '10px', }}>
                { getEnv() !== "PROD" && renderTestTag() }
                <Toolbar>
                    <Box sx={{ flexGrow: 1 }}>
                        <StyledLogo onClick={() => handleNavigate('https://consultwithkyle.com')} />
                    </Box>
                    <DesktopBox sx={{ flexGrow: 1, display: { sm: 'none', md: 'flex' }, justifyContent: 'flex-end', gap: '14px', marginTop: '-7px' }}>
                        <NavTextButton
                          onClick={() => handleNavigate('https://consultwithkyle.com/#services')}
                        >
                            Services
                        </NavTextButton>
                        <NavTextButton
                          onClick={() => handleNavigate('https://consultwithkyle.com/resources')}
                        >
                            Resources
                        </NavTextButton>
                        <NavTextButton
                          onClick={() => handleNavigate('https://consultwithkyle.com/contact-us')}
                        >
                            Contact
                        </NavTextButton>
                        <ContainedButton
                            onClick={handleMyAccountOnClick}
                            sx={{ paddingTop: '0px', paddingBottom: '0px', fontSize: '12px', paddingLeft: '18px', paddingRight: '18px' }}
                        >
                            Create An Account
                        </ContainedButton>
                    </DesktopBox>
                    <MobileBox sx={{ flexGrow: 1, justifyContent: 'flex-end' }}>
                        <IconButton
                          onClick={handleMenuOpen}
                          color="inherit"
                        >
                            <MenuIcon style={{ fontSize: 24, color: '#000' }}/>
                        </IconButton>
                    </MobileBox>
                </Toolbar>
            </AppBar>

            {renderMenu()}
        </div>
        );
}

export default withRouter(ExternalHeader);
